<template>
	<div class="rows" v-if="isVisible">
		<ValidationProvider
			ref="provider"
			:vid="`${computedName}-${generatedId}`"
			:name="options.label"
			:rules="rules"
			v-slot="{ errors, classes }"
			slim
		>
			<div :class="[options.wrapperClass, { disabled: isDisabled, 'mb-8px': errors[0] === undefined }]">
				<label class="input-label d-table w-100 text-center" v-if="options.sidebar">{{ options.label }}</label>
				<span class="input-label d-table w-100 mb-10px mt-4px" v-if="options.guide">{{ options.guide }}</span>
				<span
					:class="[
						options.tooltip ? 'input-tooltip' : '',
						options.unit ? 'input-unit' : '',
						'w-100',
						options.className,
						classes,
						inhabitantsMoreThanTen ? 'warning-field' : ''
					]"
				>
					<input
						:placeholder="options.label"
						:type="options.type"
						:name="computedName"
						:class="options.className"
						:id="generatedId"
						:value="formatValue(getData())"
						@input="handleInput"
						v-mask="options.mask"
						:inputmode="options.inputmode"
						:disabled="isDisabled"
						@change="handleChange"
						data-hj-allow
					/>
					<span v-if="options.unit" class="unit">{{ options.unit }}</span>
					<span v-if="options.tooltip" v-tooltip="options.tooltipText" class="info"></span>
				</span>
				<span v-if="inhabitantsMoreThanTen" class="warning_message warning_message--broke">
					Kérjük, ellenőrizze a lakók számánál megadott értéket!
				</span>
				<span
					:class="[
						'error_message error_message--broke',
						options.className,
						{ 'mb-8px': type === 'contracting' },
					]"
					v-if="errors[0]"
				>
					{{ errors[0] }}
				</span>
				<span class="description" v-if="options.description">{{ options.description }}</span>
			</div>
		</ValidationProvider>
	</div>
</template>

<script>
import shared from '@/mixins/shared';
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
	mixins: [shared],
	computed: {
		...mapGetters(['getMovableSum', 'getRealEstate', 'getMovables']),
		...mapGetters('contracting', ['getDisabledInputs']),
		isDisabled() {
			if (_.has(this.options, 'disabled')) {
				return this.$store.state[this.options.disabled];
			}

			if (this.type === 'contracting') {
				if (this.options.input) {
					return (
						this.disabled ||
						this.getDisabledInputs.includes(
							`${this.options.input.parent}-${this.options.input.group}-${this.options.input.prop}`,
						)
					);
				}
			}

			return this.disabled;
		},
		inhabitantsMoreThanTen() {
			if(this.name === 'inhabitants') {
				return this.getData() >= 10;
			}

			return false;
		}
	},
	methods: {
		makeNotifierErrors() {
			if (this.name === 'insurance_value' || this.name === 'floor_area' || this.name === 'movable_value') {
				if (this.$parent.$parent.$refs.notify !== undefined) {
					this.$parent.$parent.$refs.notify[0].$refs.component.makeErrors();
				}
			}

			if (
				this.options.inputGroup === 'outbuildings' &&
				(this.name === 'insurance_value' || this.name === 'floor_area')
			) {
				if (this.$parent.$parent.$refs[`outbuilding_notify-${this.index}`] !== undefined) {
					this.$parent.$parent.$refs[`outbuilding_notify-${this.index}`][0].$refs.component.makeErrors();
				}
			}
            if (
                this.options.inputGroup === 'valuables'
            ) {
                if(this.$parent.$parent.$refs['valuables_notify']  !== undefined) {
                    this.$parent.$parent.$refs['valuables_notify'][0].$refs.component.makeErrors();
                }

            }

		},
		handleInput(e) {
			this.setData(this.computedValue(e.target.value));

			setTimeout(() => {
				this.makeNotifierErrors();
			}, 1000);
		},
		handleChange(e) {
			if (this.name === 'bank_name') {
				this.$parent.$parent.$refs.bank_account_number[0].$refs.component.$refs.provider.validate();
			}

			if (this.name === 'rate') {
				const keys = _.keys(this.$parent.$parent.$refs).filter(key => key.split('-')[3] === 'rate');
				keys.forEach(key => {
					this.$parent.$parent.$refs[key][0].$refs.component.$refs.provider.validate();
				});
				5;
			}

			this.makeNotifierErrors();

			if (this.name === 'movable_value') {
				if (this.getMovableSum !== this.getRealEstate.movable_value) {
					this.getMovables.forEach((_, index) => {
						this.setInputData({
							group: 'movables',
							key: 'insurance_value',
							value: null,
							index: index,
						});
					});
				}
			}

			if (_.has(this.options, 'round')) {
				let value = Math.round(this.computedValue(e.target.value) / this.options.round) * this.options.round;
				this.setData(value);
			}
		},
	},
};
</script>

<style scoped>
.description {
	font-size: 14px;
	font-style: italic;
	text-align: center;
	display: block;
	margin-top: 10px;
}
</style>
